export const MainWrapper = 'flex flex-col w-full'

export const Headline = 'mb-4 text-black font-Roboto'

export const Link = 'mt-6 w-moz-fit w-fit'
